import axios from 'axios'
import type {
    CebiGlassInfoDto,
    GetCebiGlassRequest,
    GetMakersRequest,
    GetModelsBaseRequest,
    GetModelsRequest,
    VehiclesIdentificationDto,
    VehicleValuationDto,
    VinOnlineVehicleDto,
} from 'BrokerTsLib/src/dtos'
import type { GenericQueryOptions, VehicleValuationModel } from 'brokertslib/src/hooks'
import { longStaleTime } from 'brokertslib/src/hooks'
import { useMutation, useQuery } from '@tanstack/react-query'
import { baseUrl } from '.'

const apiUrl = import.meta.env.VITE_VINONLINE_API
const url = `${baseUrl}/${apiUrl}`

const findVehicle = (data: VehicleIdentificationPropsDto) =>
  axios.post<VinOnlineVehicleDto>(`${url}/FindVehicle`, data)
export const useFindVehicle = () => {
  return useMutation({ mutationFn: findVehicle })
}
const vehicleIdentification = (data: VehicleIdentificationPropsDto) =>
  axios.post<VehiclesIdentificationDto>(`${url}/VehicleIdentification`, data)
export const useVehicleIdentification = () => {
  return useMutation({ mutationFn: vehicleIdentification })
}

const vehicleValuation = (data: VehicleValuationModel) =>
  axios.post<VehicleValuationDto>(`${url}/VehicleValuation`, data)
export const useVehicleValuation = () => {
  return useMutation({ mutationFn: vehicleValuation })
}

const cebiGlass = (data: GetCebiGlassRequest) =>
  axios.post<CebiGlassInfoDto>(`${url}/CebiGlass`, data)
export const useCebiGlass = () => useMutation({ mutationFn: cebiGlass })

export type VehicleIdentificationPropsDto = {
  paramsId?: string
  spz?: string | null
  vin?: string | null
  techCertNumber?: string | null
}

const fetchMakers = (request: GetMakersRequest) => axios.post<string[]>(`${url}/GetMakers`, request)

const fetchAllMakers = () => axios.post<string[]>(`${url}/GetAllMakers`)

const fetchModelsBase = (request: GetModelsBaseRequest) =>
  axios.post<string[]>(`${url}/GetModelsBase`, request)

const fetchModels = (request: GetModelsRequest) => axios.post<string[]>(`${url}/GetModels`, request)

export const useGetMakers = (
  request: GetMakersRequest,
  options?: GenericQueryOptions<string[]>,
) => {
  return useQuery({
    queryKey: ['vinOnline-useGetVehicleMakers', request.categoryId, request.fuelId],
    queryFn: () => fetchMakers(request),
    staleTime: longStaleTime,
    ...options,
  })
}

export const useGetAllMakers = (
  options?: GenericQueryOptions<string[]>,
) => {
  return useQuery({
    queryKey: ['vinOnline-useGetAllVehicleMakers'],
    queryFn: () => fetchAllMakers(),
    staleTime: longStaleTime,
    ...options,
  })
}

export const useGetModelsBase = (
  request: GetModelsBaseRequest,
  options?: GenericQueryOptions<string[]>,
) => {
  return useQuery({
    queryKey: ['vinOnline-useGetModelsBase', request.categoryId, request.fuelId, request.maker],
    queryFn: () => fetchModelsBase(request),
    staleTime: longStaleTime,
    ...options,
  })
}

export const useGetModels = (
  request: GetModelsRequest,
  options?: GenericQueryOptions<string[]>,
) => {
  return useQuery({
    queryKey: [
      'vinOnline-useGetModels',
      request.categoryId,
      request.fuelId,
      request.maker,
      request.modelBase,
    ],
    queryFn: () => fetchModels(request),
    staleTime: longStaleTime,
    ...options,
  })
}
